export default {
      id: "arrow_top-usage",
      viewBox: "0 0 15 33",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#arrow_top",
      toString: function () {
        return this.url;
      }
    }